import * as React from 'react';

export const ReplyCountComponent = ({ replyCount, toggleReply }: any) => {
  if(replyCount!==0) {
    let replyText = 'replies';
    if(replyCount === 1) {
      replyText = 'Reply';
    }
    return (
      <a href="#" onClick={toggleReply}>
        View {replyCount} {replyText}
      </a>
    );
  }
  else {
    return <div />;
  }  
};


// WEBPACK FOOTER //
// ./src/modules/shared/ReplyCountComponent.tsx